import Alert from '@amzn/awsui-components-core/alert';
import Button from '@amzn/awsui-components-core/button';
import Spinner from '@amzn/awsui-components-core/spinner';
import React from 'react';
import { useStarGridText } from '../hooks/useStarGridText';

interface Props {
  readonly loading: boolean;
  readonly hasError: boolean;
  readonly onRetry: () => void;
}

export const ReportLinkStatus: React.FC<Props> = ({ loading, hasError, onRetry }) => {
  const text = useStarGridText();
  if (loading)
    return (
      <>
        <Spinner /> {text('reportLoading')}
      </>
    );
  return (
    <Alert type="error" action={<Button onClick={onRetry}>{text('refreshReport')}</Button>}>
      {text(hasError ? 'reportListLoadFailed' : 'reportLinkUnavailable')}
    </Alert>
  );
};
